export const TRANSCRIPTION_OUTPUT_MODES: Record<string, any> = {
  txt: "Text (.txt)",
  json: "Structured (.json)",
  srt: "Subtitle (.srt)",
};
